import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=4bf938b3&scoped=true&"
import script from "./Tax.vue?vue&type=script&lang=js&"
export * from "./Tax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf938b3",
  null
  
)

export default component.exports